import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedTickerRoutingModule } from './shared-ticker-routing.module';
import { SharedTickerAddComponent } from './shared-ticker-add/shared-ticker-add.component';

@NgModule({
    declarations: [SharedTickerAddComponent],
    imports: [
        CommonModule, FormsModule,
        SharedTickerRoutingModule
    ],
    exports: [SharedTickerAddComponent]
})
export class SharedTickerModule { }
